<template>
  <div
    :class="themeIsDark ? 'bg-black text-white' : 'bg-white text-black'"
    v-if="playlistId"
  >
    <div class="relative z-10 mb-10">
      <p class="text-xl font-bold text-center mb-6 max-w-244 md:max-w-xl mx-auto" :style="$themeStyle">
        {{ title }}
      </p>
      <!-- <p class="text-sm text-center">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Cumque sit, soluta commodi sunt porro amet est et mollitia libero, assumenda nesciunt. Aliquam blanditiis quaerat minus sequi minima et voluptatibus ea.</p> -->
    </div>
    <iframe
      :key="playlistUrl"
      class="mb-8"
      :src="playlistUrl"
      width="100%"
      :height="playlistHeight || '380'"
      frameborder="0"
      allowtransparency="true"
      allow="encrypted-media"
    ></iframe>
    <div>
      <div class="mb-8 mx-auto" v-if="!isAuthenticated">
        <LoginButton :title="buttonSave || 'Save to your Spotify library'" />
      </div>
      <div class="mb-8 mx-auto">
        <Button
          @click.native="share"
          :title="isCopied ? $t('trackShareCopied') : buttonShare"
        />
      </div>
      <a
        @click="onOpenClick"
        class="text-base text-center block cursor-pointer"
        :href="playlistUrlShare"
        target="_blank"
        data-umg-event-type="ShopLink"
        data-umg-target="Shopify"
        :data-umg-variant="playlistUrlShare"
        data-umg-type="Streaming"
      >
        {{ buttonOpen }}
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import { TranslationHandler } from '../../mixins/translation-handler'
import { PageModule, PageModuleDataPlaylist } from '../../types'
import { copyToClipboard } from '../../utils/copy'
import { Component, Prop, Mixins } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { ThemeHandler } from '../../mixins/theme-handler'
import LoginButton from '@/app/components/LoginButton.vue'
import cms from '@/cms'

@Component({
  components: {
    LoginButton,
  }
})
export default class ModuleSpotifyPlaylist extends Mixins(TranslationHandler, ThemeHandler) {
  @Prop() pageModule!: PageModule<PageModuleDataPlaylist>

  @Getter themeIsDark!: boolean
  @Getter themePrimaryColor!: string
  @Getter themeLogoImageUrl!: string
  @Getter isAuthenticated!: boolean

  @Getter campaignSetlistUserPlaylistId!: string
  @Getter campaignSetlistPlaylistId!: string

  isCopied = false

  get playlistId (): string {
    return this.campaignSetlistUserPlaylistId || this.campaignSetlistPlaylistId
  }

  get playlistUrl (): string {
    return `https://open.spotify.com/embed/playlist/${this.playlistId}`
  }

  get playlistUrlShare (): string {
    return `https://open.spotify.com/playlist/${this.playlistId}`
  }

  get title () {
    return this.pageModule.data[this.$tLocaleCurrent].title
  }

  get buttonSave () {
    return this.pageModule.data[this.$tLocaleCurrent].buttonSave
  }

  get buttonShare () {
    return this.pageModule.data[this.$tLocaleCurrent].buttonShare
  }

  get buttonOpen () {
    return this.pageModule.data[this.$tLocaleCurrent].buttonOpen
  }

  get playlistHeight () {
    return this.pageModule.data[this.$tLocaleCurrent].playlistHeight
  }

  onOpenClick () {
    cms.tracking.trackClickout('shop_clickout', {
      clickout_type: 'Streaming',
      shop_name: 'Spotify',
    })
  }

  async share () {
    const url = this.playlistUrlShare

    if (navigator.share) {
      cms.tracking.trackSocial('social_share_start')
      try {
        await navigator.share({
          title: this.title,
          url: url,
        })
        cms.tracking.trackSocial('social_share_success')
      } catch (e) {
        cms.tracking.trackSocial('social_share_fail', { error_message: (e as Error).toString() })
      }
    } else {
      try {
        copyToClipboard(url)
        this.isCopied = true
        cms.tracking.trackSocial('social_copy_link', { social_link: url })
      } catch (e) {
        console.log(e)
      }

      setTimeout(() => {
        this.isCopied = false
      }, 2000)
    }
  }
}
</script>
